import fecha from "fecha";
import { CUSTOM_FORMAT } from "./constants.js";
import locales from "./locales/index.js";
const toString_toString = (date, fmt = CUSTOM_FORMAT, lang)=>{
    fecha.i18n = locales[lang];
    const d = fecha.format(date, fmt);
    return d.charAt(0).toUpperCase().concat(d.slice(1));
};
const date_toString = toString_toString;
export default date_toString;
